import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import UIAssetKeys from '../UIAssetKeys';
import GameTitleText from './GameTitleText';
import FontKeys from '../FontKeys';
import LightString from './LightString';

export default class MusicDialog extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, x, y)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        const centerX = this.scene.scale.width/2;
        const centerY = this.scene.scale.height/2;

        this.bg = this.scene.add.rectangle(centerX,centerY, this.scene.scale.width, this.scene.scale.height, 0x0f75bc);
        this.add(this.bg);

        this.merryChristmas = new GameTitleText(this.scene, centerX, centerY - 240, 0.65, 60, false);
        this.add(this.merryChristmas)

        this.guitarButton = ABCyaPhaser.Buttons.addSimpleButton(centerX - 220, centerY + 200, UIAssetKeys._sprites_guitar_button, null, null, this);
        this.pianoButton = ABCyaPhaser.Buttons.addSimpleButton(centerX + 220, centerY + 200, UIAssetKeys._sprites_keyboard_button, null, null, this);

        const firstLineText = ABCyaPhaser.Text.addText(centerX, centerY - 33, 42, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("select_music_screen.information"), this, true).setOrigin(0.5);
        const secondLineText = ABCyaPhaser.Text.addText(centerX, centerY + 37, 42, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("select_music_screen.instructions"), this, true).setOrigin(0.5);
    }
}